export default __webpack_public_path__ + "static/Offshore Wind Illustration_Edit-9bfccb005b832122671a8f8394a1e5bb.mp4";